exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".segmentsBlock-0fcc4894{margin-bottom:30px}.expandlink-058738c0{line-height:2.5em}\n", ""]);

// Exports
exports.locals = {
	"segmentsBlock": "segmentsBlock-0fcc4894",
	"expandlink": "expandlink-058738c0"
};